import React, { useState } from 'react'

const Description = ({ children, className }) => {
  return <div className={`${className} text-base mb-2`}>{children}</div>
}

export default Description
